import ReopenVerify from 'components/Login/ReopenVerify';
import { SelfServiceSteps } from 'modules/selfServices/types/SelfServiceSteps';
import { ConnectionTypeLogin } from 'modules/dealers/types/ContextResponse';

import type { SelfServiceStep } from '../../../SelfServices/types';

export const REOPEN_VERIFY: SelfServiceStep = {
  key: SelfServiceSteps.REOPEN_VERIFY,
  component: ReopenVerify,
  title: {
    id: 'repairOrder.title',
    defaultMessage: 'Repair Order',
  },
  data: {
    hideHeader: true,
    isVisible: (_, config) => (
      config.connectionTypes?.includes(ConnectionTypeLogin.MFA)
      || config.connectionTypes?.includes(ConnectionTypeLogin.CODE)
    ),
  },
};
